import { PageHeader } from "@/components/PageHeader";
import { useTranslation } from "react-i18next";
import { BackButton } from "@/components/ui/BackButton";

export const CompanyNotFound = () => {
  const { t } = useTranslation();
  return (
    <div className="p-6">
      <PageHeader title={t("companies.notFound.title")} />
      <div className="mb-6">
        <BackButton 
          to="/companies" 
          label={t("companies.notFound.back")} 
        />
      </div>
      <div className="bg-white dark:bg-gray-900 rounded-sm shadow p-6">
        <p>{t("companies.notFound.message")}</p>
      </div>
    </div>
  );
};
